import { SVGProps } from "react";

const SearchIcon = ({
  width = "20.7",
  height = "20.7",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.7"
    height="20.7"
    viewBox={`${(20.7 - parseFloat(width.toString())) / 2} ${
      (20.7 - parseFloat(height.toString())) / 2
    } ${width} ${height}`}
    fill="#363636"
    stroke="#fff"
    strokeWidth="0.7px"
  >
    <g transform="translate(0.35 0.35)">
      <g transform="translate(0 0)">
        <path
          className="a"
          d="M23.651,22A8.744,8.744,0,1,0,22,23.651l4.023,4.023a1.168,1.168,0,0,0,.814.349,1.128,1.128,0,0,0,.814-.349,1.151,1.151,0,0,0,0-1.651Zm-6.93,1.116a6.4,6.4,0,1,1,6.4-6.4A6.407,6.407,0,0,1,16.721,23.116Z"
          transform="translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

export default SearchIcon;
